import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTranslation from "@babackapp/translations/use-translation";
import useQuickStats from "../lib/use-quick-stat";
import { exchangeCreditColor } from "./colors";
import { QuickStatCard } from "./quick-stat-card";

export default function QuickStatExchangeCreditCard() {
  const t = useTranslation();
  const stats = useQuickStats("exchangeCredit");
  const { data: shop } = useCurrentShopSuspense();

  return (
    <QuickStatCard
      count={stats.count}
      value={stats.value}
      currency={shop.preferences.currency}
      evolution={5}
      title={t("analyticsDashboard.resolutionTypes.exchangeCredit")}
      subtitle={t("analyticsDashboard.quickStats.exchangeCredit")}
      percentage={stats.percentage}
      color={exchangeCreditColor}
    />
  );
}
